import OtherRFV from '@/assets/SVG/OtherRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const CheckUp = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconOtherCheckup,
			} as React.CSSProperties
		}
	>
		<OtherRFV />
	</div>
);
